import { Modal as BootstrapModal } from 'bootstrap';

export default class Modal {

  constructor() {
    window.closeAction = this.closeAction;
    window.loadAction = this.loadAction.bind(this);
    window.initModalSpinner = this.initSpinner;
  }

  loadAction(URL, MODAL_TITLE, ICON, DISPLAY, MODAL_CLASS) {
    //Check for size
    const { modalSelector, modalSelectorFrame } = this.getModalSelectors(DISPLAY);

    MODAL_CLASS && this.addModalClass(MODAL_CLASS);

    this.setModalButtons(DISPLAY)

    this.initSpinner(modalSelector);

    this.setModalTitle(modalSelector, ICON, MODAL_TITLE);

    const browserName = navigator.appName;
    this.setStylesForBrowser(browserName, modalSelectorFrame);

    $(modalSelectorFrame).on('hidden.bs.modal', function (e) {
      $(modalSelectorFrame).attr("src", "about:blank");
    });

    $('.modal-backdrop').remove();

    this.onIframeLoad(modalSelectorFrame);

    const connector = URL.indexOf('?') == -1 ? '?' : '&'
    const cachedURL = URL + connector + 'cache=' + Math.random() * Math.random();
    $(modalSelectorFrame).attr('src', cachedURL);

    const modal = new BootstrapModal(modalSelector);
    modal.show();

    const self = this;
    // Modal Confirm
    $(document).off('click', '.modal-confirm');
    $(document).on('click', '.modal-confirm', function(e) {
      var iframe = $(this).closest('.modal-content').find('iframe')[0].contentWindow;
      if (typeof iframe.formSubmitHandler === 'function') {
        iframe.formSubmitHandler();
        return;
      }

      e.preventDefault();
      $(this).attr('disabled', 'disabled');  //disable button after click to prevent multiple submissions
      self.handleSubmit();
    });
  }

  setStylesForBrowser(browserName, modalSelectorFrame) {
    if (browserName == "Microsoft Internet Explorer") {
      $(modalSelectorFrame).css("height", '100%');
      $(modalSelectorFrame).css("width", '100%');
      $(modalSelectorFrame).css("overflow", 'auto');
    }
  }

  getModalSelectors(DISPLAY) {
    let modalSelector, modalSelectorFrame;

    if(DISPLAY && DISPLAY.indexOf('mini') >= 0) {
      modalSelector = '#actionMiniModalForm';
      modalSelectorFrame = '#actionFrameMini';
    } else if (DISPLAY && DISPLAY.indexOf('md') >= 0) {
      modalSelector = '#actionMdModalForm';
      modalSelectorFrame = '#actionFrameMd';
    } else if (DISPLAY && DISPLAY.indexOf('medium-modal') >= 0) {
      modalSelector = '#actionMediumModalForm';
      modalSelectorFrame = '#actionFrameMedium';
    } else if (DISPLAY && DISPLAY.indexOf('edit') >= 0) {
      modalSelector = '#actionFullModalForm';
      modalSelectorFrame = '#actionFrameFull';
    } else if (DISPLAY && DISPLAY.indexOf('full-modal') >= 0) {
      modalSelector = '#actionFullModalForm';
      modalSelectorFrame = '#actionFrameFull';
    } else {
      modalSelector = '#actionModalForm';
      modalSelectorFrame = '#actionFrame';
    }

    return {
      modalSelector,
      modalSelectorFrame,
    }
  }

  setModalButtons(DISPLAY) {
    //Check for info
    if (DISPLAY && DISPLAY.indexOf('info') >= 0 ) {
      $(".modal-ok").show();
      $(".modal-dismiss").hide();
      $(".modal-confirm").hide();
    } else if (DISPLAY && (DISPLAY.indexOf('delete') >= 0 || DISPLAY.indexOf('update') >= 0)) {
      $(".modal-ok").hide();
      $(".modal-dismiss").show();
      $(".modal-confirm").hide();
    } else if (DISPLAY && (DISPLAY.indexOf('confirm') >= 0)) {
      $(".modal-ok").hide();
      $(".modal-dismiss").show();
      $(".modal-confirm").show();
    } else if (DISPLAY && (DISPLAY.indexOf('launch') >= 0)) {
      $(".modal-ok").hide();
      $(".modal-dismiss").hide();
      $(".modal-confirm").text('Launch');
    } else {
      $(".modal-ok").hide();
      $(".modal-dismiss").show();
      $(".modal-confirm").show();
      $('.modal-confirm').removeAttr('disabled');
    }
  }

  closeAction(referer = null) {
    if (referer) {
      top.document.location = referer;
      return;
    }

    $("#actionModalForm, #actionMiniModalForm, #actionMdModalForm, #actionMediumModalForm, #actionFullModalForm").attr("src", "about:blank");
    $('#' + $('.modal.show').attr('id')).modal('hide');
    $(".modal-dismiss").hide();
  }

  addModalClass(MODAL_CLASS) {
    $('.modal-dialog').addClass(MODAL_CLASS);
  }

  onIframeLoad(modalSelectorFrame) {
    const self = this;
    $(modalSelectorFrame).on('load', function() {
      let redirectBack = false;

      // try {
      //   redirectBack = this.contentWindow.location.pathname === '/login';
      // } catch (error) {
      //   // This could throw an error if the iframe get blocked by
      //   // CORS policy for trying to access a cross-origin frame.
      //   // Which happens when the session expires and the user
      //   // try to open a modal and then that page get redirected to id.solodev.com/login
      //   console.error(error);
      //   redirectBack = true;
      // }

      if (redirectBack) {
        self.closeAction();
        let topUrl = window.top.location.href
        window.top.location.href = topUrl;
      } else {
        $(".modal-spinner").remove();
        $('.modal-confirm').removeAttr('disabled');
      }
    });
  }

  initSpinner(modalSelector, message) {
    const spinnerMarkup = `
    <div class="modal-spinner position-absolute" role="status">
      <i aria-hidden="true" class="fas fa-spinner fa-pulse"></i>
      <span class="sr-only">Loading...</span>
      ${
        message ? ('<span class="d-block loading-message">' + message + '</span>' ) : ''
      }
    </div>`;

    //Show Spinner
    $(modalSelector).find('.modal-body').prepend(spinnerMarkup);
  }

  setModalTitle(modalSelector, icon, title) {
    const modalTitle = icon
      ? `<i aria-hidden="true" class="${ icon } float-left fa-lg me-3"></i> ${ title }`
      : title;

    $(modalSelector).find('h2.card-title').html(modalTitle);
  }

  handleSubmit() {
    var actionFrame = window.document.getElementById('actionFrame').contentWindow;

    if (actionFrame.document.body?.children.length === 0) {
      const miniFrame = document.getElementById('actionFrameMini');
      if (miniFrame) {
        actionFrame = window.document.getElementById('actionFrameMini').contentWindow;
      }

      const mdFrame = document.getElementById('actionFrameMd');
      if (mdFrame) {
        actionFrame = window.document.getElementById('actionFrameMd').contentWindow;
      }

      const mediumFrame = document.getElementById('actionFrameMedium');
      if (mediumFrame) {
        actionFrame = window.document.getElementById('actionFrameMedium').contentWindow;
      }

      const fullFrame = document.getElementById('actionFrameFull');
      if (fullFrame) {
        actionFrame = window.document.getElementById('actionFrameFull').contentWindow;
      }
    }

    if (actionFrame.document.body?.children.length === 0) {
      actionFrame = top; //modal buttons can be on same page now
    }

    var actionField = '<input type="hidden" value="1" name="action">';

    for (const form of actionFrame.document.forms) {
      $(form).append( $(actionField) );

      if (typeof actionFrame.onsubmit == "function") {
      var callbackResult = actionFrame.onsubmit();
        if (callbackResult !== false) {
          form.submit();
        } else{
          $('.modal-confirm').removeAttr('disabled');
        }
      } else {
        form.submit();
      }
    }
  }
}
